import React, { useState, useEffect } from 'react';
import './Market.css';
import ImageHeader from '../ImageHeader';
import MarketMenuCategories from '../market_menu/MarketMenuCategories';
import {Zoom} from 'react-awesome-reveal';
// import SubSectionItem from './../SubSectionItem'
import {Fade} from 'react-awesome-reveal';
import TabbedMenuBox from "../TabbedMenuBox";
import DropdownContentComponent from "../dropdowns/DropdownContentComponent";
// Uncomment when dialog in use for closure
// import Dialog from '../Dialog';

export default function Market() {

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      // Function to update width state when window is resized
      const handleResize = () => {
        setWidth(window.innerWidth);
      };

      // Attach event listener for window resize
      window.addEventListener('resize', handleResize);

      // Cleanup the event listener when the component unmounts
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const faqData = [
        {
            heading: 'ORDERS',
            content:
                <>
                    <DropdownContentComponent isLong={true} btnTxt={'Is there a minimum value for orders?'} dropdownContent={
                        <span className='item_info'>The minimum order value is £60.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'How do I check your slot availability?'} dropdownContent={
                        <span className='item_info'>To check slot availability, go to the checkout page where you can view available slots in the calendar.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can someone else pick up my order?'} dropdownContent={
                        <span className='item_info'>Yes, as long as that person has your name and order number.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'What happens if I miss my collection window?'} dropdownContent={
                        <span className='item_info'>If you miss your window your order items will either be returned to or remain in Chatters restaurant where they should be available for pick-up until the end of the day. However, this is dependent on our availability that day, therefore we cannot guarantee a pick-up will be possible. Unfortunately we also cannot offer a refund in this circumstance.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can I order over the phone?'} dropdownContent={
                        <span className='item_info'>Yes, call us on 07437569985 (Monday-Fridays 10-5.00pm, Saturdays & Sundays 10-1pm) and we can place an order for you.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Will I get confirmation of my order?'} dropdownContent={
                        <span className='item_info'>Yes, you should receive an email after reaching the order confirmation page. We will then notify you on your slot date when your order is ready to collect.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can I cancel my order?'} dropdownContent={
                        <span className='item_info'>Yes, but we can only offer cancellation up to a week prior to your slot date. To cancel your order please contact katie@chattersrestaurant.co.uk or call 07879472898.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can I edit my order?'} dropdownContent={
                        <span className='item_info'>No, unfortunately once an order has been placed you cannot amend it.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can I request a refund?'} dropdownContent={
                        <span className='item_info'>Yes, if you have a problem with your order please contact katie@chattersrestaurant.co.uk or call 07879472898 and we can discuss a refund.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'What payment options do you accept?'} dropdownContent={
                        <span className='item_info'>We accept Visa and MasterCard payments.</span>}/>
                </>,
        },
        {
            heading: 'FOOD',
            content:
                <>
                    <DropdownContentComponent isLong={true} btnTxt={'Can I cook the food in the packaging it comes in?'} dropdownContent={
                        <span className='item_info'>Our items that require cooking come in aluminium containers that are suitable to go straight from your freezer/fridge to the oven, however, the plastic lid is not suitable for the oven and must be removed.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Does anything arrive frozen?'} dropdownContent={
                        <span className='item_info'>Some of the food we offer arrives frozen and is highlighted with the 'frozen' tag on the items details page. Stored at the correct temperature (-180C) these can remain frozen for up to 4 months. If defrosted, keep them refrigerated and eat within 48 hours.</span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'How do you minimise contamination when handling allergens?'} dropdownContent={
                        <span className='item_info'>To minimise risk we take extra care to thoroughly clean all equipment between each item we prepare. Despite taking every precaution to ensure prevention of allergen contamination, we cannot guarantee that our items are entirely free from allergenic substances. See our Allergen Disclaimer for more info. </span>}/>
                    <DropdownContentComponent isLong={true} btnTxt={'Can your packaging be recycled?'} dropdownContent={
                        <span className='item_info'>Yes, every items packaging is fully recyclable.</span>}/>
                </>
            ,
        },
    ];

    return <>
        <ImageHeader 
        headerText='MARKET' 
        imgPath={require('../../images/chatters-sitting-garden.jpg')}
        imgPathNarrow={require('../../images/chatters-sitting-garden-narrow.jpg')}
        isHero={true}
        />
        <div className='market_body'>

        {/* Add in when Market closed */}
        {/* <Zoom triggerOnce={true}>
        <div className='checkout_content' style={{border:'none', margin: '30px 15px 0 15px', width: '800px'}}>
            <Dialog 
                boldText={"Chatters Market currently closed"} 
                regularTextAfter={"- sorry for any inconvienince caused."}
                dialogType={'info'}
            />
        </div>
        </Zoom> */}

        <Zoom className='zoom-container' triggerOnce={true}>
            <p className='market_txt' style={{marginTop: '40px'}}><b>Chatters Market</b> is our new food service
                allowing you to conveniently place orders online and enjoy the delights of Chatters at your convenience.
                Whether it's for a special event or you're simply looking for some comfort food, you'll find exactly
                what you need here. Just choose your menu and we’ll do the rest!
            </p>
        </Zoom>
            <div className='market_info_container'>
          {width <=  1030 ? 
          <div className='step_container'>
          <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>FILL BASKET</h2>
              <img
                  className='step_img'
                  src={require('../../images/basket_filled.png')}
                  alt={"Basket"}
                  loading="eager"
                  style={{height: '58px'}}
              >
              </img>
              <span className='step_item_txt'>Browse our range and add items to your basket</span>
            </div>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <img
                className='step_arrow'
                src={require('../../images/arrow_dwn.png')}
                alt={"Arrow"}
                loading="eager"
                style={{height: '55px'}}
              >
            </img>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>CHECKOUT</h2>
              <img
                  className='step_img'
                  src={require('../../images/restaurant_icon.png')}
                  alt={"Restaurant icon"}
                  loading="eager"
              >
              </img>
              <span className='step_item_txt' style={{marginTop: '-1px'}}>Add your details, book a collection slot and pay </span>
            </div>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <img
                className='step_arrow'
                src={require('../../images/arrow_dwn.png')}
                alt={"Arrow"}
                loading="eager"
                style={{height: '55px'}}
              >
            </img>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>ENJOY</h2>
              <img
                  className='step_img'
                  src={require('../../images/food_served.png')}
                  alt={"Food"}
                  loading="eager"
                >
              </img>
              <span className='step_item_txt'>Enjoy your delicious food </span>
            </div>
            </Fade>
          </div>
          :
          <div className='step_container'>
          <Fade direction={'up'} distance={"0px"} duration={1500} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>FILL BASKET</h2>
              <img
                  className='step_img'
                  src={require('../../images/basket_filled.png')}
                  alt={"Basket"}
                  loading="eager"
                  style={{height: '58px', marginTop: '16px'}}
              >
              </img>
              <span className='step_item_txt'>Browse our range and add items to your basket</span>
            </div>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={500} triggerOnce={true}>
            <img
                className='step_arrow'
                src={require('../../images/arrow.png')}
                alt={"Arrow"}
                loading="eager"
              >
            </img>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={1000} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>CHECKOUT</h2>
              <img
                  className='step_img'
                  src={require('../../images/restaurant_icon.png')}
                  alt={"Restaurant icon"}
                  loading="eager"
              >
              </img>
              <span className='step_item_txt' style={{marginTop: '-1px'}}>Add your details, book a collection slot and pay </span>
            </div>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={1500} triggerOnce={true}>
            <img
                className='step_arrow'
                src={require('../../images/arrow.png')}
                alt={"Arrow"}
                loading="eager"
              >
            </img>
            </Fade>
            <Fade direction={'up'} distance={"0px"} duration={1500} delay={2000} triggerOnce={true}>
            <div className='step_item'>
              <h2 className='step_item_header'>ENJOY</h2>
              <img
                  className='step_img'
                  src={require('../../images/food_served.png')}
                  alt={"Food"}
                  loading="eager"
                >
              </img>
              <span className='step_item_txt'>Enjoy your delicious Chatters food</span>
            </div>
            </Fade>
          </div>
          }
        </div>
        <Zoom className='zoom-container' triggerOnce={true}>
          <h2 style={{marginTop:'30px'}}>CATEGORIES</h2>
          <div className="break"></div>
        </Zoom>
        <MarketMenuCategories />

        <Zoom className='zoom-container' triggerOnce={true}>
            <h2 className={'sub_sec_item_title'} style={{marginTop:'50px', marginBottom: '20px'}}>FREQUENTLY ASKED QUESTIONS</h2>
            <div className="break"></div>
        </Zoom>
            <div className='faqs_body'>
                <TabbedMenuBox tabData={faqData} />
            </div>
        <Zoom className='zoom-container' triggerOnce={true}>
            <p className='contact_txt'>For any further questions you might have please contact katie@chattersrestaurant.co.uk or call 07879472898.</p>
        </Zoom>
        </div>
    </>
}
